// removed by extract-text-webpack-plugin
module.exports = {"root":"GenericSettings__root___3y8O_","container":"GenericSettings__container___1tBJ5"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/GenericSettings/GenericSettings.scss
// module id = 1029
// module chunks = 0